<template>
    <div>
        <headerNav title="回答详情" />
        <div class="qmian">
            <div class="qheader">
                <div class="qheader-tit">
                    {{vtitle}}
                </div>
                <!-- <div class="qheader-stit">
                    宝宝2岁半
                    <span style="color:blue;margin-left:10px;">我来回答</span>
                </div> -->
            </div>
            <div class="answerlist">
                <comanswerlist :item="vinfo" :showtime="true"></comanswerlist>
            </div>
        </div>

        <div class="commentlist">
            <div class="mainlist">
                <div class="commentlist-mtit" v-if="totalnum">
                    <span class="commentlist-tit">所有评论</span>
                    <span>{{totalnum}}</span>
                </div>
                  <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list
                    v-model="navitem.loaded"
                    :finished="navitem.loadingType == 'nomore' ? true : false"
                    @load="loadData"
                    >
                        <div v-for="(item,index) in navitem.list" :key="index">
                            <comment :item="item"  @like="like"></comment>
                        </div>
                    </van-list>
                 </van-pull-refresh>
            </div>
        </div>
        
         <div class="qfooter" @click="gotocomment()">
            <div >
               <van-icon
                    class="answerlist-icon-icon3"
                    :size="18"
                    class-prefix="abc-icon"
                    name="xieru"
                />
                <span class="qfooter-tit">我来评论</span>
            </div>
        </div>
        <!-- <div class="qfooter">
            <div class="qfooter-btns">
               <div class="qfooter-btn">
                    <van-icon
                        class="recom-icon-icon2"
                        :size="18"
                        
                        class-prefix="abc-icon"
                        name="pinglun8"
                    />
                    <span>51</span>
                </div>
                <div class="qfooter-btn">
                    <van-icon
                        class="recom-icon-icon3"
                        :size="18"
                        class-prefix="abc-icon"
                        name="zan"
                    />
                    <span>36</span>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import comanswerlist from '@/components/common/answer/comanswerlist.vue';
import comment from '@/components/common/comment/comment.vue';
export default {
    components:{
        comanswerlist,
        comment
    },
    data(){
        return{
            vid:undefined,
            vinfo:undefined,
            vtitle:'',
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: "",
                    maxResultCount: 10,
                    skipCount: 0,
                    questionAnswersId:undefined,
                    isNeedChild:true,
                    isHasReplyCommentId:true
                },
                list: [],
            },
            loading: false,
            finished: false,
            refreshing: false,
            totalnum:undefined
        }
    },
    created(){
        var query=this.$route.query;
        this.vinfo=JSON.parse(query.item);
        console.log(this.vinfo);
        this.vid=this.vinfo.id;
        this.navitem.getparams.questionAnswersId=this.vinfo.id;
        this.vtitle=query.title;
    },
    methods:{
    like(item){
        var vindex= this.navitem.list.findIndex(x=>x.id==item.id);
        if(!item.isLike)
        {
            var model={
                questionId:item.questionId,
                QuestionAnswersId:item.questionAnswersId,
                QuestionAnswersCommentId:item.id
            };
            
            this.ajax.post('/api/services/app/PhoneQuestion/LikeAnswerComment',model).then(x=>{
                this.navitem.list[vindex].isLike=true;
                this.navitem.list[vindex].giveLikeCount+=1;
            })
        }
        else
        {
            
            this.ajax.post('/api/services/app/PhoneQuestion/CancelLikeAnswerComment?QuestionAnswersCommentId='+item.id).then(x=> {
                this.navitem.list[vindex].isLike=false;
                this.navitem.list[vindex].giveLikeCount-=1;
            })
        }
    },
    gotocomment()
    {
        this.$router.push({path:'/addcomment',query:{questionId:this.vinfo.questionId,id:this.vinfo.id}});
    },
    onRefresh() {
        this.loadData("refresh");
    },
    loadData(source) {
        let navItem = this.navitem;
        
        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
            return;
            }
        }
        if (source === "refresh") {
            this.navitem.list = [];
            this.navitem.getparams.skipCount = 0;
        }
        navItem.loadingType = "loading";
        var params = navItem.getparams;
        //加载数据
        this.ajax
            .post("/api/services/app/PhoneQuestion/QueryAnswersCommentList", params)
            .then((x) => {
            this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.totalnum=x.result.totalCount;
            this.navitem.list = this.navitem.list.concat(x.result.items);
            //console.log(this.navList);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navitem.loadingType =
                totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
            this.$set(this.navitem, "loaded", false);
            this.refreshing = false;
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.qmian{
    font-size: 13px;
    line-height: 22px;
}
.qheader{
    padding:10px 15px 5px 15px;
    background-color: #fff;
}
.qheader-tit{
    font-size: 16px;
    font-weight: bold;
}
.qheader-stit{
    color:#dadada;
}
.qheader-content{
    margin-top:5px;
}
.qanswer{
    padding: 10px 15px;
}

.answerlist{
    margin-top:10px;
    padding: 10px 15px;
    background-color: #fff;
    font-size: 14px;
}


.mainlist{
    margin: 15px;
    margin-top:5px;
    margin-bottom: 45px;
}
.commentlist{
    margin-top:10px;
    background-color: #fff;
    margin-bottom: 50px;
}
.commentlist-mtit{
    padding:10px 0;
    font-size: 14px;
}
.commentlist-tit{
    margin-right: 10px;
}


.qfooter{
    position: fixed;
    bottom: 0;
    left:0;
    right:0;
    background-color: #fff;
    text-align: center;
    padding: 15px;
    font-size: 15px;
    color:#e4c469;
    border-top:1px solid #e6e6e6;
    .qfooter-tit{
        margin-left:5px;
    }
}

// .qfooter{
//     position: fixed;
//     bottom: 0;
//     left:0;
//     right:0;
//     background-color: #fff;
//     text-align: center;
//     font-size: 15px;
//     color:#e4c469;
//     .qfooter-btn{
//         display: inline-block;
//         height: 44px;
//         line-height: 44px;
//         width: 50%;
//     }
    
// }

</style>